module.exports = __webpack_public_path__ + "static/img/冲压自动化生产线.a2bef972.png";